import { Skeleton } from "@particles/index"

import { useJobPreviewCard } from "@pages/Jobs/JobList/views/JobTimelineView/JobPreviewCard/JobPreviewCard.context"

import styles from "./JobPreviewId.module.scss"
import { JobPreviewIdProps } from "./JobPreviewId.types"

export default function JobPreviewId(props: JobPreviewIdProps) {
    const { id } = props

    const { isLoading } = useJobPreviewCard()

    if (isLoading) {
        return <Skeleton width={50} height={16} />
    }

    return <div className={styles.base}>{id}</div>
}
